<template>
    <div class="select_material_sub">
<!--        <SlatOpeningAndShutting/>-->
<!--        <WeightBar/>-->
<!--        <PelreDouble/>-->
<!--        <PelreBraiaPair/>-->
<!--        <ZephyrFeuille/>-->
<!--         <PairEnsemble/> -->
<!--        <Other/>-->
        <set-sub-attribute v-if="feature && enableSubMaterial" />
        <div class="product-size_container" :style="{ opacity: is_rect_selected ? 1 : 0.5 }">
            <h4 class="product-size_label">製品サイズ</h4>
            <div class="size_input_container">W<input type="text" pattern="^[0-9]+$" inputmode="numeric" maxlength="4" v-model="input_width" @change="updateImageWidth" :disabled="!is_rect_selected">mm</div>
            <div class="size_input_container">H<input type="text" pattern="^[0-9]+$" inputmode="numeric" maxlength="4" v-model="input_height" @change="updateImageHeight" :disabled="!is_rect_selected">mm</div>
        </div>
    </div>
</template>

<script>
    import {mapMutations , mapActions, mapGetters, mapState} from 'vuex'
    import SelectPosition from "./AddItem/SelectPosition";
    import SetSubAttribute from "../parts/SetSubAttribute.vue"

    export default {
        name: "SelectMaterialSub",
        components: {SelectPosition, SetSubAttribute},
        props: {
            enableSubMaterial: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapState('simulator', ['is_rect_selected']),
            ...mapGetters('simulator', ['feature']),
            input_width: {
                get() {
                    return this.$store.state.rect_width;
                },
                set(value) {
                    this.$store.commit('setRectWidth', value);
                    return value;
                }
            },
            input_height: {
                get() {
                    return this.$store.state.rect_height;
                },
                set(value) {
                    this.$store.commit('setRectHeight', value);
                    return value;
                }
            }
        },
        methods: {
            ...mapMutations(["setModal"]),
            ...mapMutations('simulator', ["deleteTempItem"]),
            ...mapActions(["resetTimer"]),
            ...mapActions('simulator', ["commitTempItem", "updateItemInfo"]),
            updateImageWidth() {
                const min_num = 200;
                if(isNaN(this.input_width) || this.input_width < min_num) this.input_width = min_num;
                this.updateItemInfo({rect_width: this.input_width});
            },
            updateImageHeight() {
                const min_num = 200;
                if(isNaN(this.input_height) || this.input_height < min_num) this.input_height = min_num;
                this.updateItemInfo({rect_height: this.input_height});
            },
        },

    }

</script>

<style scoped lang="scss">
    @import "../../assets/css/define";
    .select_material_sub {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        height: 100%;
        .set_sub_attr {
            flex: 0 1 calc(120 / 214 * 100%);
        }
        .product-size_container {
            flex: 0 1 calc(80 / 214 * 100%);
            .product-size_label {
                margin: 0;
                margin-bottom: 0.5em;
                font: {
                    size: clamp(10px, 1vw, 18px);
                    weight: normal;
                }
            }
            > div {
                padding-left: 1em;
                font-size: clamp(10px, 1vw, 18px);
                display: flex;
                input[type="text"] {
                    border: none;
                    border-bottom: 2px solid #000;
                    padding: 0;
                    width: 3em;
                    text-align: center;
                    margin: 0 5px;
                    font-size: 1vw;
                }
                @media (max-width: 739px) {
                    input {
                        padding: 0;
                        width: 4em;
                    }
                }
                input:focus {
                    outline: none;
                }
            }
        }
    }


</style>
